import { render, staticRenderFns } from "./DefineProjectTaskToAgent.vue?vue&type=template&id=850d3ed8&scoped=true"
import script from "./DefineProjectTaskToAgent.vue?vue&type=script&lang=js"
export * from "./DefineProjectTaskToAgent.vue?vue&type=script&lang=js"
import style0 from "./DefineProjectTaskToAgent.vue?vue&type=style&index=0&id=850d3ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850d3ed8",
  null
  
)

export default component.exports